module.exports = new __parcel__URL__("mRESVIA_carton.b6c7194b.jpg").toString();